import React from 'react';
import { Badge, TableActionButton, TableActions } from '@/components/ui';
import { Table } from '@/components/ui/Table';
import { FilePen, Archive } from 'lucide-react';
import { formatDate } from '@/lib/localeFormatters';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function TableSection() {
  return (
    <SectionWrapper title="Data Display Components">
        {/* Table */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Table</h3>
          <Table
            data={[
              { id: 1, name: 'John Doe', email: 'john@example.com', role: 'Admin', status: 'Active', created: '2024-01-15' },
              { id: 2, name: 'Jane Smith', email: 'jane@example.com', role: 'Member', status: 'Active', created: '2024-01-10' },
              { id: 3, name: 'Bob Johnson', email: 'bob@example.com', role: 'Member', status: 'Inactive', created: '2024-01-05' },
              { id: 4, name: 'Alice Brown', email: 'alice@example.com', role: 'Admin', status: 'Active', created: '2024-01-01' },
              { id: 5, name: 'Charlie Wilson', email: 'charlie@example.com', role: 'Member', status: 'Active', created: '2023-12-28' },
            ]}
            columns={[
              { key: 'name', title: 'Name', sortable: true },
              { key: 'email', title: 'Email', sortable: true },
              {
                key: 'role',
                title: 'Role',
                sortable: true,
                render: (value) => <Badge variant={value === 'Admin' ? 'secondary' : 'outline'}>{value}</Badge>
              },
              {
                key: 'status',
                title: 'Status',
                sortable: true,
                render: (value) => <Badge variant={value === 'Active' ? 'success' : 'warning'}>{value}</Badge>
              },
              { key: 'created', title: 'Created', sortable: true, render: (value: string) => formatDate(value) },
              {
                key: 'actions',
                title: 'Actions',
                align: 'right' as const,
                render: () => (
                  <TableActions>
                    <TableActionButton icon={FilePen}>Edit</TableActionButton>
                    <TableActionButton variant="destructive" icon={Archive}>Archive</TableActionButton>
                  </TableActions>
                )
              }
            ]}
            filters={[
              {
                key: 'role',
                label: 'Filter by Role',
                options: [
                  { label: 'Admin', value: 'Admin' },
                  { label: 'Member', value: 'Member' },
                ]
              },
              {
                key: 'status',
                label: 'Filter by Status',
                options: [
                  { label: 'Active', value: 'Active' },
                  { label: 'Inactive', value: 'Inactive' },
                ]
              }
            ]}
            pagination={{ pageSize: 3, showSizeChanger: true, pageSizeOptions: [3, 5, 10] }}
          />
          <CodeBlock>
{`<Table
  data={users}
  columns={[
    { key: 'name', title: 'Name', sortable: true },
    { key: 'email', title: 'Email', sortable: true },
    {
      key: 'role',
      title: 'Role',
      render: (value) => <Badge>{value}</Badge>
    },
    {
      key: 'actions',
      title: 'Actions',
      align: 'right',
      render: () => (
        <TableActions>
          <TableActionButton icon={FilePen}>Edit</TableActionButton>
          <TableActionButton variant="destructive" icon={Archive}>Archive</TableActionButton>
        </TableActions>
      )
    }
  ]}
  filters={[
    {
      key: 'role',
      label: 'Filter by Role',
      options: [
        { label: 'Admin', value: 'Admin' },
        { label: 'Member', value: 'Member' },
      ]
    }
  ]}
  pagination={{
    pageSize: 10,
    showSizeChanger: true
  }}
/>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
